/* eslint-disable no-unused-vars */
import { Grid } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUploadOutlined";
import PDialog from "../../../components/pos/PDialog";
import db from "../../../db/db";
import React, { useState } from "react";
import { useDropzone } from "react-dropzone";
import { useTranslation } from "react-i18next";
import readXlsxFile from "read-excel-file";
import { SyncUtils } from "../../../utils/SyncUtils";

export default function BulkImport(props) {
  const { t } = useTranslation();
  const translate = t;
  const [isLoaderEnabled, setIsLoaderEnabled] = useState(false);
  const [isSaveLoaderEnabled, setIsSaveLoaderEnabled] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [itemsCount, setItemsCount] = useState(0);
  const [recordsInFile, setRecordsinFile] = useState([]);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop: (acceptedFiles) => {
      setIsLoaderEnabled(true);
      acceptedFiles.map((fileItem) => {
        readXlsxFile(fileItem).then((rows) => {
          // `rows` is an array of rows
          // each row being an array of cells.
          //console.log("FFC", rows);
          setIsLoaderEnabled(false);
          setSelectedFile(fileItem);
          setItemsCount(rows.length - 1);
          setRecordsinFile(rows);
        });
      });
    },
  });

  function onCloseWindow() {
    setRecordsinFile([]);
    setSelectedFile(null);
    setItemsCount(0);
    setIsSaveLoaderEnabled(false);
    setIsLoaderEnabled(false);
    props.setOpenWindow(false);
  }

  async function handleProcessFile() {
    setIsSaveLoaderEnabled(true);
    setIsLoaderEnabled(true);
    if (selectedFile != null) {
      try {
        let data = [];
        for (let i = 1; i < recordsInFile.length; i++) {
          let productDb = await SyncUtils.searchInCacheWithBarcode(
            props.productCache,
            recordsInFile[i][0] + ""
          );

          let productBean = null;
          if (productDb) productBean = productDb.productBean;
          else {
            console.log(
              "Barcode Not found >" + recordsInFile[i][0] + "<",
              productDb
            );
            continue;
          }
          // let stockData = await db.stock
          //   .where("id")
          //   .equals(productBean.stockBean.id)
          //   .toArray();

          let currentStock = 0;
          //if (stockData.length > 0) currentStock = stockData[0].currentStock;
          //else continue;

          let item = [
            { v: i },
            { v: productBean.name },
            { v: currentStock },
            { v: recordsInFile[i][1] },
            { v: { name: recordsInFile[i][2], code: recordsInFile[i][2] } },
            //{ v: "PENDING" },
            {
              info: {
                productBean: productBean,
                barcode: recordsInFile[i][0],
              },
            },
          ];
          if (props.consolidateItems) {
            let found = false;
            for (let d of data) {
              if (item[5].info.barcode == d[5].info.barcode) {
                d[3].v = parseFloat(d[3].v) + parseFloat(item[3].v);
                found = true;
              }
            }
            if (!found) {
              data.push(item);
            }
          } else {
            data.push(item);
          }
        }
        setIsSaveLoaderEnabled(false);
        setIsLoaderEnabled(false);
        onCloseWindow();
        props.handleFileProcess(data);
      } catch (err) {
        console.log("ERROR", err);
        props.showMessage(
          "error",
          translate("Someting went wrong when processing the records")
        );
        return;
      }
    } else {
      props.showMessage("error", "Please select any file before proceed");
    }
  }

  const content = (
    <div>
      <Grid
        container
        {...getRootProps({ className: "dropzone" })}
        direction="column"
        alignItems="center"
        justify="center"
      >
        <Grid item xs={4}>
          <CloudUploadIcon
            style={{
              width: "200px",
              height: "200px",
              color: selectedFile == null ? "#c9c5c5" : "#76b587",
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <input {...getInputProps()} />
          <p>
            {selectedFile != null
              ? "Selected file name: " +
                selectedFile.name +
                " Total records: " +
                itemsCount
              : "Drag drop file here, or click to select files"}
          </p>
        </Grid>
      </Grid>
      <hr />
    </div>
  );

  return (
    <div>
      {props.openWindow && (
        <PDialog
          content={content}
          title={translate("File Seletor")}
          maxWidth={"sm"}
          fullWidth={true}
          open={true}
          onCloseWindow={onCloseWindow}
          onSave={handleProcessFile}
          saveLabel={"Process File"}
          isSaveLoaderEnabled={isSaveLoaderEnabled}
          mode={"create"}
          isLoaderEnabled={isLoaderEnabled}
        ></PDialog>
      )}
    </div>
  );
}
